import { TypedUseSelectorHook, useSelector } from 'react-redux'
import { IAuthenticatedRootState, IRootState } from '../rootReducer'

export const useTypedSelector: TypedUseSelectorHook<IRootState> = useSelector
export const useTypedAuthenticatedSelector: TypedUseSelectorHook<IAuthenticatedRootState> = useSelector
